"use client"

import useEmblaCarousel from "embla-carousel-react"

import { Indicator } from "@/components/atoms"
import { ArrowLeftIcon, ArrowRightIcon } from "@/icons"
import { useCallback, useEffect, useState } from "react"
import { EmblaCarouselType } from "embla-carousel"
import tailwindConfig from "../../../../tailwind.config"

export const CustomCarousel = ({
  variant = "light",
  items,
  align = "start",
}: {
  variant?: "light" | "dark"
  items: React.ReactNode[]
  align?: "center" | "start" | "end"
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align,
  })

  const [selectedIndex, setSelectedIndex] = useState(0)

  const maxStep = items.length

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on("reInit", onSelect).on("select", onSelect)
  }, [emblaApi, onSelect])

  const changeSlideHandler = useCallback(
    (index: number) => {
      if (!emblaApi) return
      emblaApi.scrollTo(index)
    },
    [emblaApi]
  )

  const arrowColor = {
    light: tailwindConfig.theme.extend.colors.primary,
    dark: tailwindConfig.theme.extend.colors.tertiary,
  }

  return (
    <div className="embla relative w-full flex justify-center flex-wrap">
      <div
        className="embla__viewport overflow-hidden rounded-xs "
        ref={emblaRef}
      >
        <div className="embla__container flex *:max-w-[250px] gap-3">
          {items.map((slide) => slide)}
        </div>
      </div>
      <div className="flex w-full justify-between items-center mt-4 sm:hidden">
        <div className="w-1/2">
          <Indicator
            variant={variant}
            maxStep={maxStep}
            step={selectedIndex + 1}
          />
        </div>
        <div>
          <button onClick={() => changeSlideHandler(selectedIndex - 1)}>
            <ArrowLeftIcon color={arrowColor[variant]} />
          </button>
          <button onClick={() => changeSlideHandler(selectedIndex + 1)}>
            <ArrowRightIcon color={arrowColor[variant]} />
          </button>
        </div>
      </div>
    </div>
  )
}
